export default "__VITE_ASSET___Dm0bBl2__"